import classNames from 'classnames';
import React, { useCallback, useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';

import SvgCard from '../../components/svg-card/svg-card';
import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { HTMLHeadingWithTabIndex, useFocusRef } from '../hooks';

import './informasjon.scss';

interface InformasjonProps {
    tittel: string;
    ingress: string;
    svgCard?: SvgCardType;
    onNext: () => void;
    focusOnMount: boolean;
}

export const Informasjon = ({ tittel, ingress, svgCard, onNext, focusOnMount = true }: InformasjonProps) => {
    const headerRef = useFocusRef<HTMLHeadingWithTabIndex>(focusOnMount);
    const wrapperRef = useRef<HTMLDivElement>();

    const submitOnEnter = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                onNext();
            }
        },
        [onNext],
    );

    const showHeader = () => {
        return tittel.trim().length !== 0;
    };

    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener('keypress', submitOnEnter);
        }
        return () => {
            if (wrapper) {
                wrapper.removeEventListener('keypress', submitOnEnter);
            }
        };
    }, [wrapperRef, submitOnEnter]);

    return (
        <div className="container__standard-width informasjon-sporsmal-container" ref={wrapperRef}>
            <div className={classNames({ 'informasjon-sporsmal--no-header': !showHeader() })}>
                {svgCard && <SvgCard type={svgCard} />}
                {showHeader() && (
                    <h1 className="informasjon-sporsmal-header light" tabIndex={-1} ref={headerRef}>
                        {tittel}
                    </h1>
                )}
                <ReactMarkdown>{ingress}</ReactMarkdown>
            </div>
        </div>
    );
};
